import React from 'react';
import clsx from 'clsx';
import "./flags.scss";
export const CountryFlag = props => {
  const {
    alpha2,
    style,
    className
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(`flag:${alpha2}`, className),
    style: style
  });
};